module.exports = __webpack_public_path__ + "static/img/logout.7ba341ad.png";